// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__20NZu","content":"styles_content__1hERU","checkbox":"styles_checkbox__jtKxF","checkboxLabel":"styles_checkboxLabel__21n9D"};